/**
 * Brightcove Learning Services Module
 */
var SCM = SCM || {};
SCM.Utilities = SCM.Utilities || {};

(function (bc, $) {
    bc.init = function () {
        initVideo($('.brightcove-wrapper video.video-js, .brightcove-player').not('.brightcove-wrapper-audio .brightcove-player'));
        initVideo($('.brightcove-wrapper-audio video.video-js'));
    };

    function initVideo($brightcoveVideo) {
        if ($brightcoveVideo.length) {
            var playerId = $brightcoveVideo.data('player');
            var account = $brightcoveVideo.data('account');
            var jsSrc = '//players.brightcove.net/' + account + '/' + playerId + '_default/index.min.js';
            $.getScript(jsSrc, function () {
            });
        }
    }
})(SCM.Utilities.Brightcove = SCM.Utilities.Brightcove || {}, jQuery);
